export const navigation = () => {

	const buttons = document.querySelectorAll('.toggle-navigation')

	if (!buttons) return false

	buttons.forEach(button => {
		button.addEventListener('click', e => {
			if (document.body.getAttribute('data-navigation-status')) {
				document.body.removeAttribute('data-navigation-status')
			} else {
				document.body.setAttribute('data-navigation-status', 'open')
			}
			e.preventDefault()
		})
	})

	document.onkeydown = e => {
		e = e || window.event
		if (e.keyCode == 27) document.body.removeAttribute('data-navigation-status')
	}

}

export default () => { }